import { FC, useState } from "react";
import {
  Stack,
  Box,
  useColorModeValue,
  Button,
  Center,
  Text,
} from "@chakra-ui/react";
import { Form, Formik } from "formik";
import Layout from "components/Layout";
import TextInput from "components/TextInput";
import { ILoginPayload } from "interfaces/auth";
import { forgotPasswordValidationSchema } from "utils/validationSchema";
import Logo from "components/Logo";
import useAuth from "hooks/useAuth";
import { getErrorMessage } from "utils";

const RequestDeleteAccount: FC = () => {
  const { sendRequestAccountDeletion } = useAuth();
  const [isLoading, setLoading] = useState(false);
  const [isSubmitted, setSubmitted] = useState(false);

  return (
    <Layout withSidebar={false}>
      <Center minH="100vh">
        <Box
          rounded={"lg"}
          bg={useColorModeValue("white", "gray.700")}
          boxShadow={"lg"}
          p={8}
          w="sm"
        >
          <Center mb="6">
            <Logo mb="6" w="60%" />
          </Center>
          {isSubmitted ? (
            <Text mb="10" textAlign="justify">
              Silakan cek email anda. Kami telah mengirim link penghapusan akun.
            </Text>
          ) : (
            <Text mb="4" textAlign="justify">
              Silakan isi form berikut dengan email akun anda, setelah itu kami
              akan mengirim link untuk penghapusan akun anda ke email tersebut.
            </Text>
          )}
          {!isSubmitted && (
            <Formik<ILoginPayload>
              initialValues={{ email: "", password: "" }}
              validationSchema={forgotPasswordValidationSchema}
              onSubmit={async ({ email }, helpers) => {
                try {
                  setLoading(true);
                  await sendRequestAccountDeletion({ email });
                  setLoading(false);
                  setSubmitted(true);
                } catch (error) {
                  // console.log(error);
                  helpers.setErrors({ email: getErrorMessage(error) });
                  setLoading(false);
                }
              }}
            >
              <Form>
                <Stack spacing={4}>
                  <TextInput name="email" id="email" label="Email" />
                  <Button
                    colorScheme="green"
                    type="submit"
                    isLoading={isLoading}
                  >
                    Submit
                  </Button>
                </Stack>
              </Form>
            </Formik>
          )}
        </Box>
      </Center>
    </Layout>
  );
};

export default RequestDeleteAccount;
